module.exports = __webpack_public_path__ + "static/media/podium-2nd.79915fec.png";